import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loading from "../components/common/Loading";
import {
  consumePostLoginRedirect,
  peekPostLoginRedirect,
  savePostLoginRedirect,
} from "../utils/postLoginRedirect";

function Protected({ route, user }) {
  const location = useLocation();
  const hasToken =
    sessionStorage.getItem("_t") || localStorage.getItem("_t");
  const isAuthinticated = Boolean(user && hasToken);
  const isAuthorized = route.role.includes(user?.role);
  const reDirect = peekPostLoginRedirect();

  if (hasToken && !user) {
    return <Loading customText="" />;
  }

  if (!isAuthinticated || !isAuthorized) {
    const returnPath = `${location.pathname}${location.search}`;
    savePostLoginRedirect(location.pathname, location.search);
    return <Navigate to="/login" replace state={{ from: returnPath }} />;
  }
  else if (reDirect) {
      consumePostLoginRedirect();
      return <Navigate to={reDirect} replace />
  }
  else {
    return <Outlet />;
  }
}
export default Protected;
